import { render, staticRenderFns } from "./HotLink.vue?vue&type=template&id=5d4f0c3a&"
import script from "./HotLink.vue?vue&type=script&lang=js&"
export * from "./HotLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d4f0c3a')) {
      api.createRecord('5d4f0c3a', component.options)
    } else {
      api.reload('5d4f0c3a', component.options)
    }
    module.hot.accept("./HotLink.vue?vue&type=template&id=5d4f0c3a&", function () {
      api.rerender('5d4f0c3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/footer/HotLink.vue"
export default component.exports